module.exports = __webpack_public_path__ + "static/media/text.ee28bad2.png";